import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  deleteOrder(id) {
    return axios.get(`${BASE_API}/champ/delete-so/${id}`);
  },
  getCommandStatus(id) {
    return axios.get(`${BASE_API}/champ/request-status/${id}`);
  },
  getPercentilePrices(id) {
    return axios.get(`${BASE_API}/fishbowl/order/${id}/percentile-prices`);
  },
  submitRmaHc(payload) {
    return axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/champ/add-rmahc/${payload.orderNum}`,
        data: payload
    })
  },
  approveRma(payload) {
    return axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/champ/add-return/${payload.orderNum}`,
        data: payload
    })
  },
};



// WEBPACK FOOTER //
// /src/services/champ.js